// FoodModal.jsx
import React, { useEffect, useState, useRef } from "react";
import { Modal } from "react-bootstrap";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/thumbs";
import "swiper/css/free-mode";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation } from "swiper";
import OrderCart from "../../OrderPage/OrderCart/OrderCart";
import loadingImg from "./../../../Assets/Image/LoadingSpin.gif";
import { Skeleton } from "antd";
import "./FoodModal.css";
import dineIn from "../../../Assets/Icons/DineIn.png";
import recommendations from "../../../Assets/Icons/customer.png";
import delivery from "../../../Assets/Icons/delivery-bike-circle2.png";
import clock from "../../../Assets/Icons/clock.png";
import LeoImg from "../../../Assets/Image/Leo.png";
import Rating from "react-rating";
import OutOfHourModal from "../../../components/OutOfHourModal/OutOfHourModal";
import { toast, ToastContainer } from "react-toastify";
import FoodItem from "../../../components/FoodModal/FoodItem";
const FoodModal = ({
  show,
  handleClose,
  orderDetails,
  selectedItemImage,
  selectedItemId,
  selectedIndex,
  foodDatarestaurant,
  showUnavailableReasonModal,
  setShowUnavailableReasonModal,
  showOutOfHourModal,
  setShowOutOfHourModal,
  setUpdateFoodDataStatus,
  review = "null",
  openingFrom = "",
  onAfterSaveInSearch,
}) => {
  const [tabView, setTabView] = useState(1);

  // See more and See Less functionality
  const [isExpanded, setIsExpanded] = useState(false);
  const [isExpandedStory, setIsExpandedStory] = useState(false);
  const [isExpandedDetails, setIsExpandedDetails] = useState(false);
  const [isExpandedInstruction, setIsExpandedInstruction] = useState(false);
  const [toggleDelivery, setToggleDelivery] = useState(false);
  const [selectedDelivery, setSelectedDelivery] = useState("none");
  const [dineInClickable, setDineInClickable] = useState(false);
  const [deliveryClickable, setDeliveryClickable] = useState(false);
  const [orderType, setOrderType] = useState("");
  const [isPreview, setIsPreview] = useState(false);

  const toggleDescription = (tabsName) => {
    switch (tabsName) {
      case "description":
        setIsExpanded(!isExpanded);
        break;
      case "details":
        setIsExpandedDetails(!isExpandedDetails);
        break;
      case "story":
        setIsExpandedStory(!isExpandedStory);
        break;
      case "instruction":
        setIsExpandedInstruction(!isExpandedInstruction);
        break;
    }
  };
  console.log("lll", orderDetails);

  // Run effect when orderDetails changes
  useEffect(() => {
    if (!orderDetails?.menuType) return;

    const menuTypes = orderDetails.menuType
      .split(",")
      .map((type) => type.trim());

    const hasInStore = menuTypes.includes("In-Store");
    const hasDelivery = menuTypes.includes("Delivery");

    // Reset state before re-evaluating
    setDineInClickable(false);
    setDeliveryClickable(false);
    setOrderType("");
    setSelectedDelivery("");

    if (hasInStore && !hasDelivery) {
      // Only Dine-In available
      setDineInClickable(true);
      setOrderType("0DEB06FD-2D9D-49EA-8E17-44E2958E1056");
      setSelectedDelivery("dine-in");
      setToggleDelivery(false);
    } else if (hasDelivery && !hasInStore) {
      // Only Delivery-type available
      if (!orderDetails.isDelivery) {
        // toast.warning(
        //   "Delivery toggle cannot be false if menu type is Delivery!asas",
        // );
        setIsPreview(true);
        setToggleDelivery(null);
        return;
      }

      setDeliveryClickable(true);

      if (orderDetails.isCollectionOnly) {
        // Collection-only
        setOrderType("F54272CD-371F-44F9-A8AC-34C30C2DC4FE");
        setSelectedDelivery("collection");
      } else {
        // True home delivery
        setOrderType("7CD55767-82AF-4912-AA5B-DCCBB9CCC68A");
        setSelectedDelivery("delivery");
      }
      setToggleDelivery(true);
    } else if (hasInStore && hasDelivery) {
      // Both Dine-In and Delivery available
      setDineInClickable(true);

      if (!orderDetails.isDelivery || orderDetails.isDeliveryOff) {
        // Delivery is disabled → only Dine-In active
        setDeliveryClickable(false);
        setOrderType("0DEB06FD-2D9D-49EA-8E17-44E2958E1056");
        setSelectedDelivery("dine-in");
        setToggleDelivery(false);
      } else {
        // Delivery is enabled → allow non-dine-in option
        setDeliveryClickable(true);
        setToggleDelivery(true);

        if (orderDetails.isCollectionOnly) {
          // Default to Collection
          setOrderType("F54272CD-371F-44F9-A8AC-34C30C2DC4FE");
          setSelectedDelivery("collection");
        } else {
          // Default to Home Delivery
          setOrderType("7CD55767-82AF-4912-AA5B-DCCBB9CCC68A");
          setSelectedDelivery("delivery");
        }
      }
    } else {
      // Neither In-Store nor Delivery in menuType
      toast.warning("No valid menu types provided.");
      setToggleDelivery(null);
    }
  }, [orderDetails]);

  const [detailsId, setDetailsId] = useState(null);
  const seeFullDetails = (id) => {
    setDetailsId(id);
  };

  const [instructionId, setInstructionId] = useState(null);
  const seeFullInstruction = (id) => {
    setInstructionId(id);
  };

  const handleShowScheduleModal = () => {
    setShowOutOfHourModal(true);
  };

  // See More and See Less functionality -- end

  // automatic Dine-in selection while dine-in
  // and collection both are available
  useEffect(() => {
    if (dineInClickable && deliveryClickable) {
      setSelectedDelivery("dine-in");
      setOrderType("0DEB06FD-2D9D-49EA-8E17-44E2958E1056");
    }
  }, [dineInClickable, deliveryClickable]);

  const DineInGotClicked = () => {
    if (dineInClickable) {
      setSelectedDelivery("dine-in");
      setToggleDelivery(false);
      setOrderType("0DEB06FD-2D9D-49EA-8E17-44E2958E1056");

      if (selectedDelivery !== "dine-in") {
        toast.info("Switched to Dine-In");
      }
    }
  };

  const DeliveryGotClicked = () => {
    if (!deliveryClickable) return;

    const isCollectionOnly = orderDetails?.isCollectionOnly;

    const newOrderType = isCollectionOnly
      ? "F54272CD-371F-44F9-A8AC-34C30C2DC4FE"
      : "7CD55767-82AF-4912-AA5B-DCCBB9CCC68A";

    const newSelectedMode = isCollectionOnly ? "collection" : "delivery";

    if (selectedDelivery !== newSelectedMode) {
      toast.info(
        isCollectionOnly ? "Switched to Collection" : "Switched to Delivery",
      );
    }

    setSelectedDelivery(newSelectedMode);
    setToggleDelivery(true);
    setOrderType(newOrderType);
  };

  // const scrollRef = useRef(null);

  // useEffect(()=>{
  //   const handleScroll =()=>{
  //     console.log("scroll")
  //   }
  //   const updateScroll = scrollRef.current
  //   console.log("updateScroll",scrollRef)
  //   if (updateScroll){

  //     updateScroll.addEventListener('scroll', handleScroll)
  //   }
  //   return ()=>{
  //     if (updateScroll){
  //     updateScroll.removeEventListener('scroll', handleScroll)
  //   }}
  // },[])

  const [expandedDetailIds, setExpandedDetailIds] = useState([]);
  const [expandedInstructionIds, setExpandedInstructionIds] = useState([]);

  const toggleDetailDescription = (index) => {
    setExpandedDetailIds((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index],
    );
  };

  const toggleInstructionDescription = (index) => {
    setExpandedInstructionIds((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index],
    );
  };

  return (
    <>
      <style>
        {`
          .seeMoreButton{
            color: rgb(61, 30, 25);
            font-weight: bold;
            text-decoration: none;
            font-size: .875em;
          }
          .seeMoreButton:hover{
            color: hsl(22, 94%, 14%);
          }
          .seeMoreButton:active{
            color: yellow;
          }
        `}
      </style>
      {/* <ToastContainer /> */}
      <Modal
        show={show}
        onHide={handleClose}
        className="modal-xl food-detail-modal"
        backdropClassName="food-detail-modal-backdrop"
      >
        <Modal.Body style={{ padding: "0px", borderRadius: "10px" }}>
          {orderDetails != null ? (
            <>
              <button
                type="button"
                className="btn-close btn-modal"
                onClick={handleClose}
              ></button>

              <div className="foodmodal-parent bg-black foodModalParent">
                {/* Image Section */}
                <div className="foodmodal-image d-flex justify-content-center galleryModalImgDiv">
                  <Swiper
                    spaceBetween={2}
                    grabCursor={false}
                    centeredSlides={false}
                    slidesPerView={"auto"}
                    cssMode={true}
                    pagination={{
                      dynamicBullets: true,
                    }}
                    navigation={true}
                    modules={[Pagination, Navigation]}
                    className="foodCart h-100 "
                    initialSlide={selectedIndex}
                  >
                    {selectedItemImage.foodItemImages?.length > 0 ? (
                      selectedItemImage.foodItemImages?.map((d, index) => {
                        return (
                          <SwiperSlide key={d.itemImagePath}>
                            <img
                              src={d.itemImagePath}
                              className="img-fluid "
                              alt={d.description}

                              // onClick={props.onClickInsideTest3}
                            />
                          </SwiperSlide>
                        );
                      })
                    ) : selectedItemImage.foodImageList?.length > 0 ? (
                      selectedItemImage.foodImageList?.map((d, index) => {
                        return (
                          <SwiperSlide key={d.itemImagePath}>
                            <img
                              src={d.itemImagePath}
                              className="img-fluid "
                              alt={""}

                              // onClick={props.onClickInsideTest3}
                            />
                          </SwiperSlide>
                        );
                      })
                    ) : selectedItemImage ? (
                      <SwiperSlide key={"selectedItemImage"}>
                        <img
                          src={selectedItemImage}
                          className="img-fluid"
                          alt="..."
                          // onClick={props.onClickInsideTest3}
                        />
                      </SwiperSlide>
                    ) : (
                      <SwiperSlide key="loading">
                        <img
                          src={loadingImg}
                          className="img-fluid h-10"
                          alt="..."
                          style={{
                            height: "5rem !important",
                            objectFit: "contain",
                          }}
                          // onClick={props.onClickInsideTest3}
                        />
                      </SwiperSlide>
                    )}
                  </Swiper>
                </div>

                {/* Fooditem Info Section */}
                <div className="bg-white foodModalRight">
                  {/* FoodItem Title / Header Section */}
                  <div className="card" style={{ border: "0px" }}>
                    <div className="card-body  ">
                      <div className="mb-1">
                        <div className="d-flex align-items-center">
                          {/* <h3
                            className="itemNameFoodModal align-items-center"
                            style={{ color: "#3D1E19" }}
                          >
                            <strong>
                              {orderDetails?.itemName || <Skeleton />}
                            </strong>
                          </h3>
                          <h4 style={{ marginLeft: "20px", color: "gray" }}>
                            £{orderDetails?.itemBasePrice}
                          </h4> */}
                          <h3 style={{ color: "#3D1E19" }}>
                            <strong>
                              {orderDetails?.itemName || <Skeleton />}
                            </strong>
                            <span className="text-muted ms-2">
                              £{orderDetails?.itemBasePrice}
                            </span>
                          </h3>
                        </div>

                        {/* {foodDatarestaurant && ( */}
                        <span className="ratingspan ms-0">
                          <Rating
                            className="ratingStar"
                            initialRating={Number(4.5)}
                            emptySymbol="far fa-star icon-color"
                            fullSymbol="fas fa-star icon-color"
                            readonly
                          ></Rating>
                          4.5
                        </span>
                      </div>

                      {openingFrom === "searchResult" && (
                        <>
                          <div
                            className="d-flex resrating"
                            data-bs-toggle="modal"
                            data-bs-target="#staticBackdrop"
                          >
                            <div className="logo-restaurant">
                              <img
                                src={orderDetails.restaurantLogo}
                                alt="logo"
                              />
                            </div>
                            <span>
                              <h6
                                className="resnamerating m-0"
                                style={{ color: "#3D1E19" }}
                              >
                                {orderDetails?.name}
                              </h6>
                            </span>
                            <span
                              className="ratingspan"
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <Rating
                                className="ratingStar"
                                initialRating={Number(4.5)}
                                emptySymbol="far fa-star icon-color"
                                fullSymbol="fas fa-star icon-color"
                                readonly
                                start={0}
                                stop={1}
                              ></Rating>
                              4.5
                            </span>
                          </div>
                        </>
                      )}

                      {foodDatarestaurant && (
                        <>
                          <div
                            className="d-flex resrating"
                            data-bs-toggle="modal"
                            data-bs-target="#staticBackdrop"
                          >
                            <div className="logo-restaurant">
                              <img
                                src={orderDetails.restaurantLogo}
                                alt="logo"
                              />
                            </div>
                            <span>
                              <h6
                                className="resnamerating m-0"
                                style={{ color: "#3D1E19" }}
                              >
                                {orderDetails?.name}
                              </h6>
                            </span>
                            <span
                              className="ratingspan"
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <Rating
                                className="ratingStar"
                                initialRating={Number(4.5)}
                                emptySymbol="far fa-star icon-color"
                                fullSymbol="fas fa-star icon-color"
                                readonly
                                start={0}
                                stop={1}
                              ></Rating>
                              4.5
                            </span>
                          </div>
                        </>
                      )}

                      {/* Description with see more button  */}
                      <div>
                        <p
                          className={"my-1 text-muted small"}
                          // style={{
                          //   display: '-webkit-box',
                          //   WebkitBoxOrient: 'vertical',
                          //   overflow: 'hidden',
                          //   WebkitLineClamp: isExpanded ? 'unset' : 2,
                          // }}
                        >
                          {selectedItemImage?.description}
                        </p>
                        {/* {selectedItemImage?.description?.length > 100 && (
                          <button className="seeMoreButton btn p-0" onClick={() => toggleDescription("description")}>
                            {isExpanded ? 'See less' : 'See more'}
                          </button>
                        )} */}
                      </div>

                      <div className="d-flex align-items-center">
                        <img src={LeoImg} className="me-1 userImg" alt="" />
                        <p className="my-1 text-muted small">
                          No available review for this item yet
                        </p>
                      </div>

                      {/* <div className='d-flex justify-content-between align-items-center'>
                      <div className='d-flex align-items-center'>
                        <img
                          src={selectedItemImage?.restaurantLogo}
                          className='me-1 userImg'
                          alt=''
                        />
                        <h6>{selectedItemImage?.name}</h6>
                      </div>

                      <button className="follow-BUtton btn ms-1">Follow</button>
                    </div> */}
                      <hr className="mb-0" />
                    </div>
                  </div>

                  {showOutOfHourModal && (
                    <OutOfHourModal
                      setShowOutOfHourModal={setShowOutOfHourModal}
                      foodItemName={orderDetails.itemName}
                    />
                  )}

                  <div className="d-flex align-items-center justify-content-around">
                    <div
                      className="cart-modal-icon-container"
                      onClick={handleShowScheduleModal}
                      title="Schedule"
                    >
                      <div className="cart-modal-icon">
                        <img src={clock} alt="schedule icon" />
                      </div>
                      <div className="cart-modal-icon-title">Schedule</div>
                    </div>

                    <hr className="horizontal-line" />

                    {/* Dine-In Selection */}
                    <div
                      className={`cart-modal-icon-container ${
                        selectedDelivery === "dine-in"
                          ? "cart-modal-icon-selected"
                          : ""
                      } ${!dineInClickable ? "cart-modal-icon-disabled" : ""}`}
                      title="Dine-In"
                      onClick={DineInGotClicked}
                    >
                      <div className="cart-modal-icon">
                        <img src={dineIn} alt="dine-in icon" />
                      </div>
                      <div className="cart-modal-icon-title">Dine-In</div>
                    </div>

                    <hr className="horizontal-line" />

                    {/* Delivery Selection */}
                    <div
                      className={`cart-modal-icon-container ${
                        selectedDelivery === "collection" ||
                        selectedDelivery === "delivery"
                          ? "cart-modal-icon-selected"
                          : ""
                      } ${
                        !deliveryClickable ? "cart-modal-icon-disabled" : ""
                      }`}
                      title="Delivery"
                      onClick={DeliveryGotClicked}
                    >
                      <div className="cart-modal-icon deliveryiconimg delivery-icon-container">
                        <img src={delivery} alt="delivery icon" />
                      </div>
                      <div className="cart-modal-icon-title">
                        {orderDetails?.isDelivery &&
                        orderDetails?.isCollectionOnly
                          ? "Collection"
                          : "Delivery"}
                      </div>
                      {/* <div className="cart-modal-icon-title">Collection</div> */}
                    </div>

                    <hr className="horizontal-line" />

                    {/* Recommendation */}
                    <div
                      className="cart-modal-icon-container"
                      title="Recommendation"
                    >
                      <div className="cart-modal-icon">
                        <img src={recommendations} alt="recommendation icon" />
                      </div>
                      <div className="cart-modal-icon-title">Recommend</div>
                    </div>
                  </div>

                  {orderDetails != null ? (
                    <>
                      <div className="col-12 " style={{ paddingTop: "0.5rem" }}>
                        {/* Details, Story, Instruction */}
                        <div className="">
                          <div className="col-12  d-flex justify-content-between ">
                            <button
                              data-mdb-ripple-color="dark"
                              type="button"
                              className={` dsrButton ${
                                tabView === 1 ? "onselecteddsrButton" : ""
                              }`}
                              onClick={() => {
                                setTabView(1);
                              }}
                            >
                              Details
                            </button>
                            <button
                              data-mdb-ripple-color="dark"
                              type="button"
                              className={` dsrButton ${
                                tabView === 2 ? "onselecteddsrButton" : ""
                              }`}
                              onClick={() => {
                                setTabView(2);
                              }}
                            >
                              Story
                            </button>
                            <button
                              data-mdb-ripple-color="dark"
                              type="button"
                              className={` dsrButton ${
                                tabView === 3 ? "onselecteddsrButton" : ""
                              }`}
                              onClick={() => {
                                setTabView(3);
                              }}
                            >
                              Instructions
                            </button>
                          </div>
                        </div>
                        <div className="orderCartRow mt-0">
                          {" "}
                          {/* Reduce top margin */}
                          <div className="col-12 d-flex justify-content-center">
                            <div className="col-12 d-flex justify-content-center">
                              <div className="card OrderfoodcardDetailsParagraph my-1 p-2 paragraph card-design">
                                {orderDetails && (
                                  <>
                                    {/* ---------- Tab 1: Details ---------- */}
                                    {tabView === 1 && (
                                      <>
                                        {!orderDetails.foodItemDetailList ||
                                        orderDetails.foodItemDetailList
                                          .length === 0 ? (
                                          <p className="small-font">
                                            Details not found
                                          </p>
                                        ) : (
                                          <>
                                            <div
                                              style={{
                                                display: "-webkit-box",
                                                WebkitBoxOrient: "vertical",
                                                overflow: "hidden",
                                                WebkitLineClamp:
                                                  isExpandedDetails
                                                    ? "unset"
                                                    : 6,
                                              }}
                                            >
                                              {(isExpandedDetails
                                                ? orderDetails.foodItemDetailList
                                                : orderDetails.foodItemDetailList.slice(
                                                    0,
                                                    1,
                                                  )
                                              ).map((dt, i) => (
                                                <div key={i}>
                                                  <h6
                                                    style={{
                                                      fontWeight: "bold",
                                                      marginBottom: "0px",
                                                      fontSize: "1rem",
                                                    }}
                                                  >
                                                    {dt.details?.trim()
                                                      ? dt.details
                                                      : "No Details found"}
                                                  </h6>

                                                  {dt.description?.trim() ? (
                                                    expandedDetailIds.includes(
                                                      i,
                                                    ) ? (
                                                      <p className="small-font mb-0">
                                                        {dt.description}
                                                        <button
                                                          onClick={() =>
                                                            toggleDetailDescription(
                                                              i,
                                                            )
                                                          }
                                                          className="seeMoreButton btn p-1"
                                                        >
                                                          See less
                                                        </button>
                                                      </p>
                                                    ) : dt.description.length >
                                                      80 ? (
                                                      <p className="small-font mb-0">
                                                        {dt.description.substring(
                                                          0,
                                                          60,
                                                        )}{" "}
                                                        ...
                                                        <button
                                                          onClick={() =>
                                                            toggleDetailDescription(
                                                              i,
                                                            )
                                                          }
                                                          className="seeMoreButton btn p-1"
                                                        >
                                                          See more
                                                        </button>
                                                      </p>
                                                    ) : (
                                                      <p className="small-font mb-0">
                                                        {dt.description}
                                                      </p>
                                                    )
                                                  ) : (
                                                    <p className="small-font mb-0">
                                                      No description found
                                                    </p>
                                                  )}
                                                </div>
                                              ))}
                                            </div>

                                            {orderDetails.foodItemDetailList
                                              .length > 1 && (
                                              <button
                                                className="seeMoreButton btn p-0"
                                                onClick={() =>
                                                  toggleDescription("details")
                                                }
                                              >
                                                {isExpandedDetails
                                                  ? "See less"
                                                  : "See more"}
                                              </button>
                                            )}
                                          </>
                                        )}
                                      </>
                                    )}

                                    {/* ---------- Tab 2: Story ---------- */}
                                    {tabView === 2 && (
                                      <p
                                        className="small-font m-0"
                                        style={{
                                          display: "-webkit-box",
                                          WebkitBoxOrient: "vertical",
                                          overflow: "hidden",
                                          WebkitLineClamp: isExpandedStory
                                            ? "unset"
                                            : 3,
                                        }}
                                      >
                                        {orderDetails.foodItemStory?.story?.trim()
                                          ? isExpandedStory
                                            ? orderDetails.foodItemStory.story
                                            : orderDetails.foodItemStory.story
                                                  .length > 60
                                              ? `${orderDetails.foodItemStory.story.substring(
                                                  0,
                                                  60,
                                                )} ... `
                                              : orderDetails.foodItemStory.story
                                          : "No Story found"}

                                        {orderDetails.foodItemStory?.story
                                          ?.length > 160 && (
                                          <button
                                            className="seeMoreButton btn p-0"
                                            onClick={() =>
                                              toggleDescription("story")
                                            }
                                          >
                                            {isExpandedStory
                                              ? " See less"
                                              : " See more"}
                                          </button>
                                        )}
                                      </p>
                                    )}

                                    {/* ---------- Tab 3: Instruction ---------- */}
                                    {tabView === 3 && (
                                      <>
                                        {!orderDetails.foodItemInstructionList ||
                                        orderDetails.foodItemInstructionList
                                          .length === 0 ? (
                                          <p className="small-font">
                                            Instruction Details not found
                                          </p>
                                        ) : (
                                          <>
                                            <div
                                              style={{
                                                display: "-webkit-box",
                                                WebkitBoxOrient: "vertical",
                                                overflow: "hidden",
                                                WebkitLineClamp:
                                                  isExpandedInstruction
                                                    ? "unset"
                                                    : 6,
                                              }}
                                            >
                                              {(isExpandedInstruction
                                                ? orderDetails.foodItemInstructionList
                                                : orderDetails.foodItemInstructionList.slice(
                                                    0,
                                                    1,
                                                  )
                                              ).map((dt, i) => (
                                                <div key={i}>
                                                  <h6
                                                    style={{
                                                      fontWeight: "bold",
                                                      marginBottom: "0px",
                                                      fontSize: "1rem",
                                                    }}
                                                  >
                                                    {dt.name?.trim()
                                                      ? dt.name
                                                      : "No Title"}
                                                  </h6>

                                                  {dt?.description?.trim() ? (
                                                    expandedInstructionIds.includes(
                                                      i,
                                                    ) ? (
                                                      <p className="small-font mb-0">
                                                        {dt.description}
                                                        <button
                                                          onClick={() =>
                                                            toggleInstructionDescription(
                                                              i,
                                                            )
                                                          }
                                                          className="seeMoreButton btn p-1"
                                                        >
                                                          See less
                                                        </button>
                                                      </p>
                                                    ) : dt.description.length >
                                                      80 ? (
                                                      <p className="small-font mb-0">
                                                        {dt.description.substring(
                                                          0,
                                                          60,
                                                        )}{" "}
                                                        ...
                                                        <button
                                                          onClick={() =>
                                                            toggleInstructionDescription(
                                                              i,
                                                            )
                                                          }
                                                          className="seeMoreButton btn p-1"
                                                        >
                                                          See more
                                                        </button>
                                                      </p>
                                                    ) : (
                                                      <p className="small-font mb-0">
                                                        {dt.description}
                                                      </p>
                                                    )
                                                  ) : (
                                                    <p className="small-font mb-0">
                                                      No description found
                                                    </p>
                                                  )}
                                                </div>
                                              ))}
                                            </div>

                                            {orderDetails
                                              .foodItemInstructionList.length >
                                              1 && (
                                              <button
                                                className="seeMoreButton btn p-0"
                                                onClick={() =>
                                                  toggleDescription(
                                                    "instruction",
                                                  )
                                                }
                                              >
                                                {isExpandedInstruction
                                                  ? "See less"
                                                  : "See more"}
                                              </button>
                                            )}
                                          </>
                                        )}
                                      </>
                                    )}
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                          <br></br>
                        </div>
                        {/* mobileDisplay end */}
                      </div>

                      {/* <OrderCart
                        handleClose={handleClose}
                        orderDetails={orderDetails}
                        from={"modal"}
                        itemId={selectedItemId}
                        selectedItem={selectedItemImage}
                        showUnavailableReasonModal={showUnavailableReasonModal}
                        setShowUnavailableReasonModal={
                          setShowUnavailableReasonModal
                        }
                        showOutOfHourModal={showOutOfHourModal}
                        setShowOutOfHourModal={setShowOutOfHourModal}
                        setUpdateFoodData={setUpdateFoodDataStatus}
                        orderType={orderType}
                      /> */}
                      <FoodItem
                        mode="add"
                        food={orderDetails}
                        handleClose={handleClose}
                        orderType={orderType}
                        showUnavailableReasonModal={showUnavailableReasonModal}
                        setShowUnavailableReasonModal={
                          setShowUnavailableReasonModal
                        }
                        isPreview={isPreview}
                        showOutOfHourModal={showOutOfHourModal}
                        setShowOutOfHourModal={setShowOutOfHourModal}
                        setUpdateFoodData={setUpdateFoodDataStatus}
                        onAfterSaveInSearch={onAfterSaveInSearch}
                      />
                    </>
                  ) : (
                    <img
                      src={loadingImg}
                      className="img-fluid h-10"
                      alt="..."
                      style={{
                        height: "5rem !important",
                        objectFit: "contain",
                      }}
                      // onClick={props.onClickInsideTest3}
                    />
                  )}
                </div>
              </div>
            </>
          ) : (
            // <div className='d-flex justify-content-center'>
            //   <div>
            //     <img
            //       src={loadingImg}
            //       className='img-fluid h-10'
            //       alt='...'
            //       style={{
            //         height: '5rem !important',
            //         objectFit: 'contain',
            //       }}
            //       // onClick={props.onClickInsideTest3}
            //     />
            //   </div>
            // </div>
            <div className="d-flex justify-content-center">
              <div className="w-100">
                <Skeleton.Image
                  className="img-fluid w-100"
                  style={{
                    height: "300px",
                  }}
                />

                <div className="card" style={{ border: "0px" }}>
                  <div className="card-body">
                    <h3 style={{ color: "#3D1E19" }}>
                      <Skeleton active />
                    </h3>
                    <p className="my-1 text-muted">
                      <Skeleton active />
                    </p>
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="d-flex align-items-center">
                        <Skeleton.Avatar className="me-1" active />
                        <h6>
                          <Skeleton active />
                        </h6>
                      </div>
                    </div>
                    <hr className="mb-0" />
                  </div>
                </div>
                <div style={{ marginTop: "20px" }}>
                  <Skeleton active paragraph={{ rows: 3 }} />
                </div>
              </div>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default FoodModal;
